// extracted by mini-css-extract-plugin
export var chevron = "_it-2";
export var dropdownItems = "_it-0";
export var item = "_it-1";